import { dayjs } from '@brands/ui/utils'

export function formatDecimalHoursToTime(decimalHours: number) {
  const hours = Math.floor(decimalHours)
  const minutes = Math.round((decimalHours - hours) * 60)
  return `${hours}:${minutes.toString().padStart(2, '0')}`
}

export function formatDate(date?: Date | string | null, format = 'MM/DD/YYYY') {
  if (!date) return ''
  return dayjs(date).isValid() ? dayjs(date).format(format) : ''
}
